import { render, staticRenderFns } from "./updPlan.vue?vue&type=template&id=360c1fe6"
import script from "./updPlan.vue?vue&type=script&lang=js"
export * from "./updPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports